import { createSlice } from "@reduxjs/toolkit";

export const dailySlice = createSlice({
  name: "dailySpace",
  initialState: {
    dailyState: {},
  },
  reducers: {
    setDailyState(state, { type, payload }) {
      switch (type) {
        case "dailySpace/setDailyState":
          state.dailyState = {
            ...state.dailyState,
            ...payload,
          };
          break;
      }
    },
  },
});
const { setDailyState } = dailySlice.actions;
export { setDailyState };
export const dailyStateSelector = (state: any) => state.dailyReducer.dailyState;
export default dailySlice.reducer;
